import {
  DOMAIN_EVENT_FEED_LOOKBACK_MS,
  DOMAIN_EVENT_LOG_MAX_ROWS,
} from '../model/constants';

import type { DomainEventFrame } from '../model';

/**
 * Leading rows of an id-ascending log whose `ts` is before `cutoffMs`. It stops
 * at the first row inside the window: concurrent producers can commit a lower
 * id with a later `ts`, so a stale row behind it waits for a later trim.
 */
export const staleHeadCount = (
  events: readonly DomainEventFrame[],
  cutoffMs: number,
): number => {
  let count = 0;

  while (count < events.length && events[count].ts < cutoffMs) {
    count += 1;
  }

  return count;
};

/** How many of the oldest rows to drop so the log holds 48 h and at most the ceiling. */
export const domainEventLogTrimCount = (
  events: readonly DomainEventFrame[],
  nowMs: number,
): number =>
  Math.max(
    staleHeadCount(events, nowMs - DOMAIN_EVENT_FEED_LOOKBACK_MS),
    events.length - DOMAIN_EVENT_LOG_MAX_ROWS,
  );
